export default __webpack_public_path__ + "static/media/Mercenary's Harness of the Untamed.3f4cedf9.jpg";